import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PerformanceCard from "components/card/PerformanceCard";
import { Button } from "antd";
import HeaderModal from "components/modal/HeaderModal";
import StartMonthlyReviewForm from "./StartMonthlyReviewForm";
import {
  getPendingPerfReviewList
} from "../../../../../redux/performancereview/performanceReviewState";
import { addActiveModal, removeActiveModal } from '../../../../../redux/layout/layoutState';
import { useNavigate } from "react-router-dom";

const ConductMonthlyReview = () => {
  
  const [activeRecord, setActiveRecord] = useState(null);

  const dispatch = useDispatch();
  
  useEffect(() => {
      dispatch(getPendingPerfReviewList({pending: 1}));
  },[dispatch]);

  const navigate = useNavigate();

  const modalName = 'monthly_perf_review';

  const recordList = useSelector((state) => state.performanceReview.pendingPerfReviewList.items);
  const activeModals = useSelector((state) => state.layout.activeModals);
  const isModalOpen = activeModals?.includes(modalName);

  const openModal = (record) => {
    if (record.type?.opt_code === "PFR_MONTHLY") {
      setActiveRecord(record);
      dispatch(addActiveModal(modalName));
      return;
    }

    navigate(`/console/performance-reviews/${record.pfr_id}/edit`);
  };

  const closeModal = () => {
    setActiveRecord(null);
    dispatch(removeActiveModal(modalName));
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-3 mb-3">
      {recordList.map((record, index) => (
        <PerformanceCard
          key={index}
          recordData={record}
        >
          <div className="w-full flex flex-col space-y-2">
            <a
              className="btn btn-gradient-emerald p-2 text-sm w-full block text-center hover:text-white"
               onClick={() => openModal(record)}
            >
              Start {record?.task_title}
            </a>
          </div>
        </PerformanceCard>
      ))}

      {activeRecord && (
        <HeaderModal
          open={isModalOpen}
          onClose={closeModal}
          title={`Monthly Rating for ${activeRecord.employee_name}`}
          description={`${activeRecord.employee.emp_title}`}
          width="700px"
        >
            <StartMonthlyReviewForm recordData={activeRecord}/>
        </HeaderModal>
      )}
    </div>
  );
};

export default ConductMonthlyReview;
